import React from 'react';
import styled from 'styled-components';
import { Popup } from "semantic-ui-react";

const MIN_BAR_WIDTH = 50; // Minimum width in pixels for each bar
const MAX_TITLE_LENGTH = 25;

const MiniQuestionChart = ({ data, title }) => {
    if (!data || data.length === 0) {
        return null;
    }

    // Filter out items with 0 count
    const filteredData = data.filter(item => item.count > 0);
    const shouldTruncateTitle = title.length > MAX_TITLE_LENGTH;
    const displayTitle = shouldTruncateTitle ? `${title.substring(0, MAX_TITLE_LENGTH)}...` : title;

    return (
        <OuterContainer>
            <TitleContainer>
                {shouldTruncateTitle ? (
                    <Popup
                        content={title}
                        position="top left"
                        inverted
                        trigger={<Title>{displayTitle}</Title>}
                    />
                ) : (
                    <Title>{title}</Title>
                )}
            </TitleContainer>
            <Container>
                <BarContainer>
                    {filteredData.map((item, index) => (
                        <Popup
                            key={index}
                            content={`${item.count} responses`}
                            position="top center"
                            inverted
                            trigger={
                                <BarSection
                                    width={item.data[0]}
                                >
                                    <Bar color={item.color}>
                                        <Percentage>{Math.round(item.data[0])}%</Percentage>
                                    </Bar>
                                </BarSection>
                            }
                        />
                    ))}
                </BarContainer>
            </Container>
        </OuterContainer>
    );
};

export default MiniQuestionChart;

const OuterContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    width: 100%;
`;

const TitleContainer = styled.div`
    min-width: 160px;
    max-width: 160px;
    display: flex;
    align-items: center;
`;

const Title = styled.div`
    font-size: 14px;
    color: #2A3039;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
`;

const Container = styled.div`
    background-color: #f9fafb;
    padding: 12px;
    border-radius: 8px;
    flex: 1;
    min-width: ${MIN_BAR_WIDTH * 2.5}px;
`;

const BarContainer = styled.div`
    display: flex;
    height: 24px;
    border-radius: 4px;
    gap: 2px;
    justify-content: space-between;
`;

const BarSection = styled.div`
    width: ${props => props.width}%;
    min-width: ${MIN_BAR_WIDTH}px;
    transition: width 0.3s ease;
`;

const Bar = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${props => props.color};
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding-left: 4px;
`;

const Percentage = styled.span`
    font-size: 11px;
    color: white;
    font-weight: bold;
`;
